import styled from '@emotion/styled';
import React from 'react';
import { BsPencil } from 'react-icons/bs';
import { ToolTip } from '../../../../../_elements/ToolTip';
import Initials from '../../../../Features/Common/Initials';
import { ActionStyles } from '../../../reusableStyles';

function PublicGPSItem({ channel, setShow }) {
	return (
		<StyledPublicGpsItem>
			<div className="d-flex team">
				<div>
					{channel?.teamData?.avatar ? (
						<img src={channel?.teamData?.avatar} alt="channel" className="channel_icon" />
					) : (
						<Initials name={channel?.teamData?.name} id={channel?.teamData?._id} size="50px" />
					)}
				</div>
				<div className="mx-4">
					<div className="font-weight-bold">{channel?.title}</div>
					<div className="small">team: {channel?.teamData?.name}</div>
				</div>
			</div>
			<div className="mr-4 category">
				{channel?.premiumPinCategory?.pin ? (
					<ToolTip text={channel?.premiumPinCategory?.name}>
						<div className="d-flex flex-column align-items-center justify-content-center">
							<img
								src={channel?.premiumPinCategory?.pin}
								alt={channel?.premiumPinCategory?.name}
								width={50}
								height={50}
								style={{ objectFit: 'contain' }}
							/>
						</div>
					</ToolTip>
				) : channel?.normalPinCategory?.pin ? (
					<ToolTip text={channel?.normalPinCategory?.name}>
						<div className="d-flex flex-column align-items-center justify-content-center">
							<img
								src={channel?.normalPinCategory?.pin}
								alt={channel?.normalPinCategory?.name}
								width={50}
								height={50}
								style={{ objectFit: 'contain' }}
							/>
						</div>
					</ToolTip>
				) : null}
			</div>
			<div className="buttons">
				<ActionStyles>
				<ToolTip text={'Edit'} side={'top'} cssStyles={"top:-70% !important; min-width: fit-content !important"}>
					<BsPencil
						className="icon"
						onClick={() =>
							setShow({
								id: channel.id || channel._id,
								activeCategoryName:
									channel?.premiumPinCategory?.name || channel?.normalPinCategory?.name || null,
							})
						}
					/>
					</ToolTip>
				</ActionStyles>
			</div>
		</StyledPublicGpsItem>
	);
}

export default PublicGPSItem;

export const StyledPublicGpsItem = styled.div`
	&.heading {
		background: #50aeb0db;
		color: white;
	}
	display: flex;
	justify-content: space-between;
	padding: 10px 30px;
	margin: 10px 0;
	border: 1px solid #e0f0ef;
	border-radius: 5px;
	.team {
		width: 300px;
	}
	.category {
		width: 200px;
		text-align: center;
	}
	.buttons {
		width: 200px;
		text-align: center;
	}
	.channel_icon {
		width: 50px;
		height: 50px;
		border-radius: 50%;
	}
`;
